
import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from './ContactForm';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const Contact = () => {
  return (
    <div>
      <main>
        {/* Address Start */}
        <section className="address mt-12">
          <div className="container mx-auto px-4">
            <motion.div
              className="row mb-8"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <div className="col-lg-12 text-center">
                <h1 className="text-3xl font-bold mb-2">Contact Us</h1>
                <h2 className="text-xl text-gray-600">Your questions matter, we're here to help!</h2>
              </div>
            </motion.div>

            <div className="row grid grid-cols-1 md:grid-cols-3 gap-8">
              {[...Array(3)].map((_, index) => (
                <motion.div
                  key={index}
                  className="col-span-1"
                  custom={index}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={fadeInUp}
                >
                  <div className="address__single bg-white p-6 rounded-lg shadow-md flex flex-col h-full">
                    {/* You can customize each card content separately */}
                    {index === 0 && (
                      <>
                        <div className="flex items-center mb-4">
                          <div className="mr-4 text-green-600 text-2xl">📍</div>
                          <h4 className="text-xl font-semibold">Address</h4>
                        </div>
                        <p className="text-gray-700 mb-3">
                          Bldg no. 2, Nalanda SRA CHSL, Office no. F 4 , 1st floor,<br />
                          Jawahar Rd, behind Suchita Business Park,<br />
                          Ghatkopar East, Mumbai, Maharashtra 400077
                        </p>
                        <a
                          href="https://maps.app.goo.gl/mXdsT5eid2SLakrv5"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-sm text-green-600 hover:text-green-800 font-medium mt-auto"
                        >
                          View on Google Maps ↗
                        </a>
                      </>
                    )}

                    {index === 1 && (
                      <>
                        <div className="flex items-center mb-4">
                          <div className="mr-4 text-green-600 text-2xl">✉️</div>
                          <h4 className="text-xl font-semibold">Email Id</h4>
                        </div>
                        <p>
                          <a
                            href="mailto:info@environaturesolution.com"
                            className="text-blue-600 hover:text-blue-800"
                          >
                            info@environaturesolution.com
                          </a>
                        </p>
                        <div className="mt-5">
                          <h5 className="font-medium">Open Hours</h5>
                          <p className="text-gray-700">Mon - Fri: 10:00 AM - 06:00 PM</p>
                        </div>
                      </>
                    )}

                    {index === 2 && (
                      <>
                        <div className="flex items-center mb-4">
                          <div className="mr-4 text-green-600 text-2xl">📞</div>
                          <h4 className="text-xl font-semibold">Contact Number</h4>
                        </div>
                        <p>
                          <a href="tel:+91-9326897902" className="text-blue-600 hover:text-blue-800 block mb-2">
                            +91-9326897902
                          </a>
                          <a href="tel:+91-9322811574" className="text-blue-600 hover:text-blue-800 block">
                            +91-9322811574
                          </a>
                        </p>
                      </>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="contact-one py-16">
          <div className="container mx-auto px-4">
            <motion.div
              className="section-title text-center mb-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <span className="text-green-600 font-medium block mb-2">
                Connect with us
              </span>
              <h2 className="text-3xl font-bold">
                Feel free to write us anytime
              </h2>
            </motion.div>

            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <ContactForm />
            </motion.div>

            <motion.div
              className="row grid grid-cols-1 gap-8 mt-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <div className="google-map h-full">
                <iframe
                  title="Environature Solution Location"
                  width="100%"
                  height="600"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  className="rounded-lg shadow-md"
                  src="https://maps.google.com/maps?cid=17424187822661199759&amp;output=embed"
                ></iframe>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;
